import script from "./UpCarTari.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpCarTari.vue?vue&type=script&lang=ts&setup=true"

import "./UpCarTari.vue?vue&type=style&index=0&id=24cf9736&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24cf9736"]])

export default __exports__